/** @type {import("@mui/material").ThemeOptions} */
const baseThemeOptions = {
  components: {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "36px",
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          ":last-child": {
            paddingBottom: "16px",
          },
        },
      },
    },
  },
};

// https://github.com/binwiederhier/ntfy-android/blob/main/app/src/main/res/values/colors.xml

/** @type {import("@mui/material").ThemeOptions} */
export const lightTheme = {
  ...baseThemeOptions,
  components: {
    ...baseThemeOptions.components,
  },
  palette: {
    mode: "light",
    primary: {
      main: "#1D74F5",
    },
    secondary: {
      main: "#4A9AFF",
    },
    error: {
      main: "#c30000",
    },
  },
};

/** @type {import("@mui/material").ThemeOptions} */
export const darkTheme = {
  ...baseThemeOptions,
  components: {
    ...baseThemeOptions.components,
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          color: "#000",
          backgroundColor: "#1A5BB0",
        },
      },
    },
  },
  palette: {
    mode: "dark",
    background: {
      paper: "#1b2124",
    },
    primary: {
      main: "#1D74F5",
    },
    secondary: {
      main: "#6cead0",
    },
    error: {
      main: "#fe4d2e",
    },
  },
};
